import { render, staticRenderFns } from "./DeliveryConfigDefaults.vue?vue&type=template&id=3b0ffb5e&"
import script from "./DeliveryConfigDefaults.vue?vue&type=script&lang=js&"
export * from "./DeliveryConfigDefaults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b0ffb5e')) {
      api.createRecord('3b0ffb5e', component.options)
    } else {
      api.reload('3b0ffb5e', component.options)
    }
    module.hot.accept("./DeliveryConfigDefaults.vue?vue&type=template&id=3b0ffb5e&", function () {
      api.rerender('3b0ffb5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/store/components/DeliveryConfigDefaults.vue"
export default component.exports